module.exports = __webpack_public_path__ + "static/media/headerLogo.60fde03d.png";